export function snakeToCamel(raw: string): string {
  const splt = raw.split(/ |_/g);
  let str = '';
  for (let i = 0; i < splt.length; i += 1) {
    const word = splt[i];
    if (word == null || word.length === 0) {
      continue;
    }

    if (str.length === 0) {
      str = word.toLowerCase();
      continue;
    }

    str += word[0].toUpperCase() + word.slice(1, word.length);
  }

  return str;
}

export function camelToSnake(raw: string): string {
  const uppercaseSplit = raw.split(/(?=[A-Z])/);
  let str = '';
  for (let i = 0; i < uppercaseSplit.length; i += 1) {
    const single = uppercaseSplit[i];
    if (single == null || single.length === 0) {
      continue;
    }

    if (str.length > 0) {
      str += '_';
    }

    str += single.toLowerCase();
  }

  return str;
}

export function capitalize(raw: string): string {
  if (raw == null) {
    return '';
  }
  return raw.charAt(0).toUpperCase() + raw.slice(1);
}

export function returnInitials(firstName: string, lastName: string): string {
  if (firstName.length === 0 && lastName.length === 0) {
    return '';
  }
  return capitalize(firstName[0]) + capitalize(lastName[0]);
}

export function returnFirstLetter(input: string): string {
  if (input.length === 0) {
    return '';
  }
  return input.charAt(0).toUpperCase();
}

export function abbreviateName(input: string): string {
  if (input.length === 0) {
    return '';
  }
  return input.substring(0, 2).toUpperCase();
}

export function removeAccents(input: string): string {
  if (input.length === 0) {
    return '';
  }
  return input.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function dasherize(input: string): string {
  if (input.length === 0) {
    return '';
  }
  return removeAccents(input).replace(/ /g, '-');
}
